import './ultimeleModificari.css'

function UltimeleModificari(props) {
    return (
        <div id="modificari-container">
            <div id="modificari-label" >

                <img id="mod-close-btn" alt='close button' src="/img/close-btn-x.svg" onClick={() => props.onClose() } />
                
                <div className="modificari-content">
                    <div id='title'>ULTIMELE MODIFICARI</div>
                    <div className='mod-content versiune'>V 4.13<span className='mod-date'>17 Mar 2025</span></div>
                    <div className='mod-content'>Ultimele modificari</div>
                    <div className='mod-content versiune'>V 4.12<span className='mod-date'>13 Mar 2025</span></div>
                    <div className='mod-content'>Buton "Neinteresanta". Butonul de "Interesanta" merge. Arata ultimul anunt si licitatie selectata. Selectia este diferita pentru teren si casa</div>
                </div>
            </div>
        </div>
    );
}

export default UltimeleModificari;